<template lang="pug">
modal#envelope-sent-modal(
  :showCancelButton='false'
  :title='$t("modal.envelopeSent.title")'
  @closed='redirectDocuments'
  @process='closeModal'
  process-button-label='Ok'
  ref='modal'
  size='sm'
)
  .text {{ $t('modal.envelopeSent.message') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/envelope-sent.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'EnvelopeSentModal',
  components: {
    Modal,
  },
  methods: {
    redirectDocuments() {
      this.$router.push('/business/documents/sent');
    },
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
